module.exports = __webpack_public_path__ + "components/discount-pages/db-journey/static/db-1920@2x-d3612f17d8c3d14031921e0412a5a12e.jpg";